import { format } from 'date-fns';
import AwesomeDebouncePromise from 'awesome-debounce-promise';

class MembershipInfo {
  constructor(element) {
    if (!(element instanceof HTMLElement)) {
      throw new TypeError('Invalid element');
    }

    this.currentDate = new Date();
    this.signatureRows = element.querySelectorAll('.signature__row');
    this.submitButton = element.querySelector('button[type="submit"]');
    this.init();
  }

  formatDate(date) {
    return format(date, 'd/LL/y HH:mm:ss');
  }

  init() {
    this.signatureRows.forEach((row, idx) => {
      const signatureInput = row.querySelector(`#members-${idx + 1}-signature`);
      const signaturePreview = row.querySelector(`#members-${idx + 1}-signature-preview`);
      const signatureTimeInput = row.querySelector(`#members-${idx + 1}-signature-time`);
      const signatureTimePreview = row.querySelector('.signature__time');
      const signatureEntered = AwesomeDebouncePromise((displayDate, dateInput) => this.handleSignatureInput(displayDate, dateInput), 500);
      signatureInput.addEventListener('keyup', (e) => {
        signaturePreview.innerHTML = signatureInput.value;
        signatureEntered(signatureTimePreview, signatureTimeInput);
      });
    });

    this.maybeUpdateButtonStatus();
  }

  allSignaturesComplete() {
    return Array.from(this.signatureRows).find((row, idx) => {
      const signatureInput = row.querySelector(`#members-${idx + 1}-signature`);
      return signatureInput.value === '';
    }) === undefined;
  }

  handleSignatureInput(displayDate, dateInput) {
    this.currentDate = new Date();
    displayDate.innerHTML = this.formatDate(this.currentDate);
    dateInput.value = this.formatDate(this.currentDate);
    this.maybeUpdateButtonStatus();
  }

  maybeUpdateButtonStatus() {
    if (this.submitButton) {
      this.submitButton.disabled = !this.allSignaturesComplete();
    }
  }
}

export default MembershipInfo;
